<template>
  <div class="passenger">
    <claim-person
      v-for="passenger in passengers"
      :key="passenger.Id"
      :person="passenger"
      :documentId="documentId"
    ></claim-person>
  </div>
</template>

<script>
import ClaimPerson from '@/components/person/ClaimPerson.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimPassengers',
  props: {
    documentId: {
      type: String,
      default () {
        return ''
      }
    }
  },
  components: {
    ClaimPerson
  },
  computed: {
    ...mapGetters({
      passengers: 'claim/claimPassengers'
    })
  }
}
</script>
